/*
 * Copyright (c) 2022 Puratos. All rights reserved.
 */

import ContentLoader from "react-content-loader";
import {SkeletonSettings} from "../../../../../atoms/effects/skeletons/utils/SkeletonSettings";
import React from "react";

export const OrderRowSkeletonMobile = (props) => (
    <ContentLoader
        width={"100%"}
        height={250}
        speed={SkeletonSettings.SPEED}
        backgroundColor={SkeletonSettings.BACKGROUND}
        foregroundColor={SkeletonSettings.FOREGROUND}
        style={{backgroundColor: "#fff", borderRadius: "4px", marginBottom: "12px"}}
        {...props}>

        {/* Order number and label */}
        <rect x="16" y="16" rx="3" ry="3" width="15%" height="10"/>
        <rect x="16" y="46" rx="3" ry="3" width="10%" height="10"/>
        <rect x={`calc(10% + 27px)`} y="41" rx="3" ry="3" width="12%" height="20"/>

        {/* Order reference */}
        <rect x="50%" y="16" rx="3" ry="3" width="25%" height="10"/>
        <rect x="50%" y="36" rx="3" ry="3" width="25%" height="10"/>

        {/* Creation date */}
        <rect x="16" y={`calc(30% + 10px)`} rx="3" ry="3" width="25%" height="10"/>
        <rect x="16" y={`calc(30% + 30px)`} rx="3" ry="3" width="25%" height="10"/>

        {/* Ship-to number */}
        <rect x="50%" y={`calc(30% + 10px)`} rx="3" ry="3" width="25%" height="10"/>
        <rect x="50%" y={`calc(30% + 30px)`} ry="3" width="25%" height="10"/>

        {/* City */}
        <rect x="16" y={`calc(55% + 10px)`} rx="3" ry="3" width="25%" height="10"/>
        <rect x="16" y={`calc(55% + 30px)`} rx="3" ry="3" width="25%" height="10"/>

        {/* View more button */}
        <rect x="35%" y={`calc(100% - 60px)`} rx="3" ry="3" width="30%" height="40"/>

    </ContentLoader>
);
